import "./ImageSection.css";

const ImageSection = () => {
  return (
    <section className="image-section">
      <div className="image-section__container">
        <img
          src="/images/home/extra/extra.webp"
          alt="Ảnh dưới banner"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default ImageSection;
